export default function CloseIcon() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6.5L6 12.5M12 12.5L6 6.5M1.5 1.25H16.5C16.9142 1.25 17.25 1.58579 17.25 2V17C17.25 17.4142 16.9142 17.75 16.5 17.75H1.5C1.08579 17.75 0.75 17.4142 0.75 17V2C0.75 1.58579 1.08579 1.25 1.5 1.25Z"
        stroke="#B721FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
